import {combineReducers} from "redux";
import list from "./list";
import update from "./update";

export default combineReducers({list,update});
